import { render, staticRenderFns } from "./floating-menu-sites.vue?vue&type=template&id=708cf197&scoped=true"
import script from "./floating-menu-sites.vue?vue&type=script&lang=js"
export * from "./floating-menu-sites.vue?vue&type=script&lang=js"
import style0 from "./floating-menu-sites.vue?vue&type=style&index=0&id=708cf197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cf197",
  null
  
)

export default component.exports